// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;O pray for the peace of Jerusalem:&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;&#145;May they prosper who love you.<br> </p> </div></div>";
// Exports
module.exports = code;